import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBrandingLoading } from '../../redux/slices/branding/brandingSlice';
import { useGetTeamBrandingConfigQuery } from '../../services/api';
import { applySessionBranding, brandingFromTeam } from './sessionBranding';

const useBrandingHandler = () => {
  const dispatch = useDispatch();

  const { data: brandingConfig } = useGetTeamBrandingConfigQuery(undefined, {
    skip: window.location.pathname.includes('/login'),
  });

  useEffect(() => {
    if (!brandingConfig) return;

    dispatch(setBrandingLoading(true));

    try {
      const isSponsorsActive = Boolean(brandingConfig?.data?.isSponsorsActive);
      const agentVisualizationConfig = brandingConfig?.data?.agentVisualizationConfig || null;

      applySessionBranding(
        dispatch,
        brandingFromTeam(brandingConfig?.data, { isSponsorsActive, agentVisualizationConfig })
      );

      dispatch(setBrandingLoading(false));
    } catch (e) {
      dispatch(setBrandingLoading(false));
    }
  }, [brandingConfig, dispatch]);
};

export default useBrandingHandler;
